module.exports = __webpack_public_path__ + "img/section8.dcc27195.png";